/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-var-requires*/

import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {AppStateService} from "./service/app-state.service";
import locale_au from '@angular/common/locales/en-AU';
import locale_ca from '@angular/common/locales/en-CA';
import locale_fr from '@angular/common/locales/fr';
import locale_ja from '@angular/common/locales/ja';
import {registerLocaleData} from "@angular/common";
import merge from 'lodash/merge';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'talent-app';

  constructor(private translate: TranslateService,
              private appState: AppStateService) {
    // @ts-ignore
    registerLocaleData(locale_au);
    registerLocaleData(locale_fr);
    registerLocaleData(locale_ja);
    registerLocaleData(locale_ca);

    const enTranslations = require('../assets/i18n/en_us.json');
    const frTranslations = merge({}, enTranslations, require('../assets/i18n/fr_fr.json'));
    const jaTranslations = merge({}, enTranslations, require('../assets/i18n/ja_jp.json'));
    const gbTranslations = merge({}, enTranslations, require('../assets/i18n/en_uk.json'));
    const caTranslations = merge({}, enTranslations, require('../assets/i18n/en_ca.json'));
    const auTranslations = merge({}, gbTranslations, require('../assets/i18n/en_au.json'));
    const nlTranslations = merge({}, enTranslations, require('../assets/i18n/en_nl.json'));
    translate.setTranslation('en-AU', auTranslations);
    translate.setTranslation('en-CA', caTranslations);
    translate.setTranslation('en-GB', gbTranslations);
    translate.setTranslation('en-US', enTranslations);
    translate.setTranslation('en-NL', nlTranslations);
    translate.setTranslation('fr', frTranslations);
    translate.setTranslation('ja', jaTranslations);
    appState.locale$.subscribe(locale => {
      if (['en-AU', 'en-CA', 'en-GB', 'en-US'].includes(locale)) {
        translate.use(locale);
      } else {
        const lang = locale.split('-')[0];
        translate.use(['fr', 'ja'].includes(lang) ? lang : 'en-US');
      }
    });
    translate.setDefaultLang('en-US');
  }
}
